import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import HeaderBar from "../components/HeaderBar"
import "@fontsource/m-plus-1p/100.css"
import "@fontsource/m-plus-1p/300.css"
import "../components/Page.css"
import SideLabel from "../components/SideLabel";
import BackGround from "../components/BackGround";
import ConceptSection from "../components/ConceptSection";
import WhoAmISection from "../components/WhoAmISection";
import WorksSection from "../components/WorksSection";
import ClientWorksSection from "../components/ClientWorksSection";
import ContactSection from "../components/ContactSection";
import BottomBar from "../components/BottomBar";
import HankaBumonSection from "../components/HankaBumonSection";
import ScrollController from "../components/ScrollController";
import {useRef, useState} from "react";
import FixedDecoration from "../components/FixedDecoration";
// @ts-ignore
import {Helmet} from "react-helmet";

const IndexPage:React.FC = () => {
    // @ts-ignore
    const parentRef = useRef(null as HTMLDivElement);
    const [currentSection,setCurrentSection] = useState(0);
    return(
        <div style={{overflow:"hidden"}}>
            <Helmet>
                <meta charSet={"utf-8"}/>
                <title>Hirai's Portfolio</title>
            </Helmet>
            <BackGround currentSection={currentSection}/>
            <FixedDecoration/>
            <SideLabel currentSection={currentSection}/>
            <div className={"Sections"} ref={parentRef}>
                <ScrollController parentRef={parentRef} setCurrentSection={setCurrentSection}>
                    <ConceptSection isActive={currentSection == 0}/>
                    <WhoAmISection isActive={currentSection == 1}/>
                    <WorksSection isActive={currentSection == 2}/>
                    <ClientWorksSection isActive={currentSection == 3}/>
                    <HankaBumonSection isActive={currentSection == 4}/>
                    <ContactSection isActive={currentSection == 5}/>
                </ScrollController>
            </div>
            <HeaderBar/>
        </div>
    )
}

export default IndexPage
